import { useInView } from 'react-intersection-observer';

import * as s from './styles';

import type { IIframeProps } from './types';

const heightMap = {
  short: '40rem',
  medium: '80rem',
  tall: '120rem',
};

const Iframe = ({
  backgroundColor = 'light',
  forceRender = false,
  heightType = 'medium',
  title,
  url,
  ...props
}: IIframeProps) => {
  const { ref, inView } = useInView({ threshold: .25 });

  return (
    <s.IframeModule
      {...props}
      $backgroundColor={backgroundColor}
      ref={ref}
    >
      <s.IframeGrid>
        {(inView || forceRender) && (
          <s.StyledIframe
            title={title}
            src={url}
            $height={heightMap[heightType]}
          />)
        }
      </s.IframeGrid>
    </s.IframeModule>
  );
};

export default Iframe;
